import React from 'react';
import { Button } from 'antd';
import { motion } from 'framer-motion';

/**
 * A button that is a pill and knows it -- rounded, and it springs a little
 * under the cursor and gives under the thumb.
 *
 * This lived inside the booking wizard, which is where the look was first
 * settled. It is the app's button, not that screen's: every primary action
 * elsewhere either repeats these three lines by hand or, more often, doesn't,
 * and reads as a plain antd rectangle next to the ones that do.
 *
 * Takes everything Button takes, so it is a drop-in wherever a `<Button>`
 * already is. `shape` is fixed -- a PillButton that isn't a pill would be a
 * Button.
 */
const PillButton: React.FC<Omit<React.ComponentProps<typeof Button>, 'shape'>> = ({ children, ...props }) => (
  <motion.div
    style={{ display: 'inline-block', width: props.block ? '100%' : undefined }}
    whileHover={{ scale: 1.03 }}
    whileTap={{ scale: 0.98 }}
    transition={{ duration: 0.15 }}
  >
    <Button shape="round" {...props}>
      {children}
    </Button>
  </motion.div>
);

export default PillButton;
